import React, { FC } from 'react';

import { Navigate } from 'react-router-dom';

import router from '~/core/router';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { ProfileType } from '~/types/profile';

interface Props {
  Component: FC;
  checkAvailability?: (profile: ProfileType) => boolean;
}

const UnAuthorizedRoute: FC<Props> = ({ Component, checkAvailability }) => {
  const profile = useAppSelector((state) => state.profile);

  return (
    <>
      {checkAvailability ? (
        checkAvailability(profile) ? (
          <Component />
        ) : (
          <Navigate to={router.getDefaultPrivateRoutePath()} />
        )
      ) : (
        <Component />
      )}
    </>
  );
};

export default UnAuthorizedRoute;
